import { initializeDB, OFFLINE_STORE_NAME } from './database'
import { OfflineFile } from '@/types'

export async function saveOfflineFile(file: OfflineFile): Promise<void> {
  const db = await initializeDB()
  const tx = db.transaction(OFFLINE_STORE_NAME, 'readwrite')

  // Strip non-serializable data before saving to IDB — only persist metadata and progress
  const { fileHandle, ...metadata } = file

  await tx.store.put({
    ...metadata,
    addedAt: metadata.addedAt || new Date().toISOString(),
    updatedAt: metadata.updatedAt || new Date().toISOString(),
  })
  await tx.done
}

export async function getAllOfflineFiles(): Promise<OfflineFile[]> {
  const db = await initializeDB()
  return db.getAll(OFFLINE_STORE_NAME)
}

export async function updateOfflineFileProgress(id: string, progress: number): Promise<void> {
  const db = await initializeDB()
  const file = await db.get(OFFLINE_STORE_NAME, id)
  if (file) {
    const tx = db.transaction(OFFLINE_STORE_NAME, 'readwrite')
    const { fileHandle, ...metadata } = file
    await tx.store.put({
      ...metadata,
      playProgress: progress,
    })
    await tx.done
  }
}

export async function updateOfflineFile(id: string, updates: Partial<Pick<OfflineFile, 'title'>>): Promise<void> {
  const db = await initializeDB()
  const file = await db.get(OFFLINE_STORE_NAME, id)
  if (file) {
    const tx = db.transaction(OFFLINE_STORE_NAME, 'readwrite')
    const { fileHandle, ...metadata } = file
    await tx.store.put({
      ...metadata,
      ...updates,
      updatedAt: new Date().toISOString(),
    })
    await tx.done
  }
}

/** Bump `updatedAt` on an existing file without changing anything else. */
export async function touchOfflineFile(id: string): Promise<void> {
  const db = await initializeDB()
  const file = await db.get(OFFLINE_STORE_NAME, id)
  if (file) {
    const tx = db.transaction(OFFLINE_STORE_NAME, 'readwrite')
    const { fileHandle, ...metadata } = file
    await tx.store.put({
      ...metadata,
      updatedAt: new Date().toISOString(),
    })
    await tx.done
  }
}

export async function deleteOfflineFile(id: string): Promise<void> {
  const db = await initializeDB()
  await db.delete(OFFLINE_STORE_NAME, id)
}
